/**
 * @file 错误上报，一般作为入口的第一个导入，确保一开始就setup
 * @author fuqiang15
 */
import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import request from '@/common/utils/musesRequest';

Raven
    .config(`http://8617aaf5360d487b989d3d5a42f32c6d@${location.host}/18`, {
        transport(opts) {
            if (process.env.NODE_ENV !== 'development') {
                return request(opts);
            }
        }
    })
    .addPlugin(RavenVue, Vue)
    .install();
